import { get } from 'lodash';

import TopNavigationSelector from 'state/selectors/top-navigation';

const setCurrentNavigationNode = (action, prevState, nextState) => {
  const currentNode = TopNavigationSelector.getCurrentNode(nextState);
  const handle = get(currentNode, ['handle']);

  if (!handle) {
    return null;
  }

  return {
    hitType: 'event',
    eventAction: 'openSubNav',
    eventCategory: 'Navigation',
    eventLabel: handle,
    eventValue: 1,
  };
};

export { setCurrentNavigationNode };
